import { QExcelPubRow } from "./QExcelPubRow";
import { QXMLObject } from "./QXMLObject";

export class QExcelPub extends QXMLObject {
  constructor() {
    super();
    this.fRootRow = null;
  }

  InitExcelPub(rootObj) {
    this.SetXMLElementName("excelpub");
    var rr = new QExcelPubRow();
    rr.InitExcelRow(rootObj);
    this.fRootRow = rr;
  }

  OutputSubElements(stream) {
    this.fRootRow.OutputToXML(stream);
  }

  OutputChildElements(stream) {}
}
